import Repository from '@/repositories/marketing'
const resource = '/acquisition/builders'

export default {
  fetch(config) {
    return Repository.get(`${resource}.json`, config)
  },
  create(payload, config) {
    return Repository.post(`${resource}.json`,payload, config)
  },
  update(builderId, payload) {
    return Repository.put(`${resource}/${builderId}.json`, payload)
  },
  show(builderId) {
    return Repository.get(`${resource}/${builderId}.json`)
  },
  getDomains(builderId) {
    return Repository.get(`${resource}/${builderId}.json`)
  },
  delete(builderId) {
    return Repository.delete(`${resource}/${builderId}.json`)
  },
  bulkDelete(config) {
    return Repository.delete(`${resource}/bulk_delete.json`, config)
  },
  duplicate(builderId) {
    return Repository.get(`${resource}/${builderId}/duplicate.json`)
  },
  validateName(config){
    return Repository.get(`${resource}/validate_name.json`, config)
  },
  validateDomain(config){
    return Repository.get(`${resource}/validate_domain.json`, config)
  },
  createBuilder(payload){
    return Repository.get(`${resource}/save_builder.json`, payload)
  },
  getTemplates(payload){
    return Repository.get(`${resource}/get_templates.json`, payload)
  },
  getBuilderInfo(builderId){
    return Repository.get(`${resource}/${builderId}/get_builder_info.json`)
  },
  createUpdateBuilder(payload){
    return Repository.post(`${resource}/create_or_update_new_aqua_form.json`, payload)
  },
  getTemplateDetails(payload){
    return Repository.get(`${resource}/get_details_of_template.json`, payload)
  }
}
